import { FC } from "react";
import { IOrderTemplateResponse } from "@miplatform/types";
import { Radio } from "@mui/material";
import { ConfigCard } from "../../components";

export const ConfigAttachedOrderTemplateCard: FC<
  ConfigAttachedOrderTemplateCardProps
> = ({ item, selectedId, onSelect, isReadOnly }) => {
  const isSelected = selectedId === item.id;

  return (
    <ConfigCard
      title={item.name}
      additionalTitleText={[item.module]}
      additionalCardTextBold={"Attached WO's: "}
      additionalCardText={
        item.workOrderTemplates?.length > 0
          ? item.workOrderTemplates?.map((wot) => wot.name).join(", ")
          : "None"
      }
      LeftComponent={
        <Radio
          checked={isSelected}
          disabled={isReadOnly}
          size="small"
          sx={{ padding: 0 }}
        />
      }
      onClick={() => !isReadOnly && onSelect(item)}
      isSelected={isSelected}
    />
  );
};

interface ConfigAttachedOrderTemplateCardProps {
  item: IOrderTemplateResponse;
  selectedId: string | null;
  onSelect: (template: IOrderTemplateResponse) => void;
  isReadOnly?: boolean;
}
